module.exports = __webpack_public_path__ + "img/shop-page.66ad0bef.png";